class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer?.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle?.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]')?.addEventListener('click', this.close.bind(this));

    this.summaryToggle?.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.classList.add('overflow-hidden');

    // Delay adding body click listener to prevent the current click from triggering it
    setTimeout(() => {
      document.body.addEventListener('click', this.onBodyClickEvent);
    }, 0);

    // Get the input element
    const input = this.detailsContainer.querySelector('input:not([type="hidden"])');
    
    // Force focus on the input and keep it there
    // This is needed because predictive-search's onFocusOut can steal focus on intermediate screen sizes
    const forceFocus = () => {
      if (input && this.detailsContainer.hasAttribute('open')) {
        input.focus();
      }
    };

    // Initial focus after a delay to let animations start
    setTimeout(() => {
      trapFocus(
        this.detailsContainer.querySelector('[tabindex="-1"]'),
        input
      );
      // Force focus multiple times to ensure it sticks
      forceFocus();
      setTimeout(forceFocus, 50);
      setTimeout(forceFocus, 150);
      setTimeout(forceFocus, 300);
    }, 10);
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
